import React from 'react';
import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import {
  CARBON_MODEL_VERSION,
  COMPLIANCE_INVENTORY_LABEL,
  CO2E_METHODOLOGY_SUBTITLE,
} from '../../constants/carbonVisualization';

interface ComplianceMethodologyBadgeProps {
  compact?: boolean;
  modelVersion?: string;
}

export const ComplianceMethodologyBadge: React.FC<ComplianceMethodologyBadgeProps> = ({
  compact = false,
  modelVersion,
}) => {
  const version = modelVersion || CARBON_MODEL_VERSION;

  if (compact) {
    return (
      <Tooltip title={`${COMPLIANCE_INVENTORY_LABEL}. Model ${version}. ${CO2E_METHODOLOGY_SUBTITLE}`}>
        <Chip
          size="small"
          icon={<VerifiedUserIcon />}
          label={`ISO 14064 · v${version}`}
          color="primary"
          variant="outlined"
        />
      </Tooltip>
    );
  }

  return (
    <Stack spacing={0.5}>
      <Chip
        size="small"
        icon={<VerifiedUserIcon />}
        label={COMPLIANCE_INVENTORY_LABEL}
        color="primary"
        variant="outlined"
        sx={{ alignSelf: 'flex-start' }}
      />
      <Typography variant="caption" color="text.secondary">
        Carbon model v{version}. {CO2E_METHODOLOGY_SUBTITLE}
      </Typography>
    </Stack>
  );
};

export default ComplianceMethodologyBadge;
